<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="exsbsettlement_createdAt"
        class="form-control-label">createdAt</label>
      <input
        id="exsbsettlement_createdAt"
        v-model="item.createdAt"
        :class="['form-control', isInvalid('createdAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('createdAt', $event.target.value)">
      <div
        v-if="isInvalid('createdAt')"
        class="invalid-feedback">{{ violations.createdAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbsettlement_updatedAt"
        class="form-control-label">updatedAt</label>
      <input
        id="exsbsettlement_updatedAt"
        v-model="item.updatedAt"
        :class="['form-control', isInvalid('updatedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('updatedAt', $event.target.value)">
      <div
        v-if="isInvalid('updatedAt')"
        class="invalid-feedback">{{ violations.updatedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbsettlement_deletedAt"
        class="form-control-label">deletedAt</label>
      <input
        id="exsbsettlement_deletedAt"
        v-model="item.deletedAt"
        :class="['form-control', isInvalid('deletedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('deletedAt', $event.target.value)">
      <div
        v-if="isInvalid('deletedAt')"
        class="invalid-feedback">{{ violations.deletedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbsettlement_createdBy"
        class="form-control-label">createdBy</label>
      <input
        id="exsbsettlement_createdBy"
        v-model="item.createdBy"
        :class="['form-control', isInvalid('createdBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('createdBy', $event.target.value)">
      <div
        v-if="isInvalid('createdBy')"
        class="invalid-feedback">{{ violations.createdBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbsettlement_updatedBy"
        class="form-control-label">updatedBy</label>
      <input
        id="exsbsettlement_updatedBy"
        v-model="item.updatedBy"
        :class="['form-control', isInvalid('updatedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('updatedBy', $event.target.value)">
      <div
        v-if="isInvalid('updatedBy')"
        class="invalid-feedback">{{ violations.updatedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbsettlement_deletedBy"
        class="form-control-label">deletedBy</label>
      <input
        id="exsbsettlement_deletedBy"
        v-model="item.deletedBy"
        :class="['form-control', isInvalid('deletedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('deletedBy', $event.target.value)">
      <div
        v-if="isInvalid('deletedBy')"
        class="invalid-feedback">{{ violations.deletedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbsettlement_state"
        class="form-control-label">state</label>
      <input
        id="exsbsettlement_state"
        v-model="item.state"
        :class="['form-control', isInvalid('state') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('state', $event.target.value)">
      <div
        v-if="isInvalid('state')"
        class="invalid-feedback">{{ violations.state }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbsettlement_case"
        class="form-control-label">case</label>
      <input
        id="exsbsettlement_case"
        v-model="item.case"
        :class="['form-control', isInvalid('case') ? 'is-invalid' : '']"
        type="text"
        required="true"
        placeholder=""
        @input="handleUpdateField('case', $event.target.value)">
      <div
        v-if="isInvalid('case')"
        class="invalid-feedback">{{ violations.case }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbsettlement_positions"
        class="form-control-label">positions</label>
      <input
        id="exsbsettlement_positions"
        v-model="item.positions"
        :class="['form-control', isInvalid('positions') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('positions', $event.target.value)">
      <div
        v-if="isInvalid('positions')"
        class="invalid-feedback">{{ violations.positions }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbsettlement_valueNetto"
        class="form-control-label">valueNetto</label>
      <input
        id="exsbsettlement_valueNetto"
        v-model="item.valueNetto"
        :class="['form-control', isInvalid('valueNetto') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('valueNetto', $event.target.value)">
      <div
        v-if="isInvalid('valueNetto')"
        class="invalid-feedback">{{ violations.valueNetto }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbsettlement_valueBrutto"
        class="form-control-label">valueBrutto</label>
      <input
        id="exsbsettlement_valueBrutto"
        v-model="item.valueBrutto"
        :class="['form-control', isInvalid('valueBrutto') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('valueBrutto', $event.target.value)">
      <div
        v-if="isInvalid('valueBrutto')"
        class="invalid-feedback">{{ violations.valueBrutto }}</div>
    </div>

    <button
      type="submit"
      class="btn btn-primary">Submit</button>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
